import * as React from "react";

export interface DisplayIconProps {
    className?: string;
    onClick?: () => void;
}

export const DisplayIcon = (props: DisplayIconProps) => {
    const style = props.onClick ? {cursor: "pointer"} : null;

    return (
        <svg style={style} onClick={props.onClick} version="1.1" id="display-mode"  x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50"><path fill="#FFFFFF" d="M47.6,36.7H2.2c-1.1,0-2-0.9-2-2V5.1c0-1.1,0.9-2,2-2h45.4c1.1,0,2,0.9,2,2v29.6C49.6,35.8,48.7,36.7,47.6,36.7
	z"/>
<path fill="#959595" d="M23.8,44v-7.3h-6.1c-0.8,0-1.5-0.5-1.5-1.3s0.6-1.2,1.4-1.2l29.7,0l0-28.7l-44.8,0l0,13.7
	c0,0.8-0.4,1.5-1.2,1.5S0.2,20,0.2,19.2V4.6c0-0.8,0.7-1.5,1.5-1.5h46.7c0.8,0,1.5,0.7,1.5,1.5v30.7c0,0.8-0.7,1.5-1.5,1.5H26.2V44
	h6.1c0.8,0,1.5,0.5,1.5,1.4c0,0.8-0.7,1.3-1.6,1.3H17.6c-0.8,0-1.4-0.5-1.4-1.3c0-0.8,0.7-1.4,1.5-1.4H23.8z"/>
<circle fill="#8DCECA" cx="1.6" cy="35.2" r="1.5"/>
<path fill="#8DCECA" d="M8.2,35.2c0,0.8-0.7,1.5-1.5,1.5S5.3,36,5.3,35.2c0-2-1.6-3.7-3.7-3.7c-0.8,0-1.5-0.7-1.5-1.5
	c0-0.8,0.7-1.5,1.5-1.5C5.3,28.6,8.2,31.6,8.2,35.2z"/>
<path fill="#8DCECA" d="M13.3,35.2c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-4.8-3.9-8.8-8.8-8.8c-0.8,0-1.5-0.7-1.5-1.5
	s0.7-1.5,1.5-1.5C8.1,23.5,13.3,28.8,13.3,35.2z"/>
</svg>
    
    );
};

export default DisplayIcon;
